import React from 'react';
import { Input, Form } from 'antd';
import { injectIntl } from 'react-intl';
import PersonalInformationContext from './PersonalInformationContext';
import { validateEmail } from '../../Utils/FormValidators';
import message from '../../Containers/ManualSearchV2/ManualSearchMessages';

const { Item } = Form;

function Email(props) {
  const { initialValue, isNameMasked,intl } = props;
  const { form } = React.useContext(PersonalInformationContext);

  return (
    <Item colon={false}>
      {form.getFieldDecorator('Email', {
        initialValue,
        rules: [
          {
            validator: validateEmail,
          },
        ],
      })(<Input style={{ overflow: 'hidden' }} placeholder={intl.formatMessage({ ...message.enterEmailAddressLabel })} disabled={isNameMasked} />)}
    </Item>
  );
}

export default (injectIntl(Form.create()(Email)));
export { Email as EmailWithoutIntl };
